module.exports = __webpack_public_path__ + "img/logo3.f3a4f536.png";